module.exports = __webpack_public_path__ + "img/is_charging_icon.1dae39a9.png";